import { toggleContent } from '../accordion';

export function getBodyContent() {
  const fixedWrapper = document.querySelector('.cmp-fixed-wrapper');
  return fixedWrapper ?? document.body;
}

export function buttonIsExpanded(button) {
  return button.getAttribute('aria-expanded');
}

export function registerToggles() {
  return document.querySelectorAll('.toggle-menu-button');
}

export function toggleMenuHandler(button, content) {
  const expandedValue = button.getAttribute('aria-expanded');

  if (expandedValue === 'true') {
    content.classList.add('menu--isOpen');
  } else {
    content.classList.remove('menu--isOpen');
  }
}

export function toggleMenu(buttons, content) {
  buttons.forEach((button) => button.addEventListener('click', () => toggleMenuHandler(button, content)));
}

export function getContent(button) {
  if (!button) return null;
  const buttonAriaControl = button.getAttribute('aria-controls');
  return document.getElementById(buttonAriaControl);
}

export function handleClickOutsideMenu(event) {
  const button = document.querySelector('.toggle-menu-button[aria-expanded="true"]');
  const contentId = button?.getAttribute('aria-controls');
  const activeContentElement = document.querySelector(`#${contentId}`);
  const bodyContent = getBodyContent();

  if (button && !button.contains(event.target) && !activeContentElement.contains(event.target)) {
    toggleContent({ target: button });
    bodyContent.classList.remove('menu--isOpen');
  }
}

export function handleFocusOutsideMenu(event) {
  const button = document.querySelector('.toggle-menu-button[aria-expanded="true"]');
  const activeContentElement = getContent(button);
  const bodyContent = getBodyContent();

  if (
    activeContentElement
    && !button.contains(event.target)
    && !activeContentElement.contains(event.target)
  ) {
    toggleContent({ target: button });
    bodyContent.classList.remove('menu--isOpen');
  }
}
